import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Clipboard } from '@angular/cdk/clipboard';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../../../environments/environment';

import { IOrganization } from '@shared/models/organization';

import { Store } from '@ngrx/store';
import { AppState } from '@state/app.state';
import { selectAuthUser } from '@state/auth/auth.selectors';

const fbUrl = `https://www.facebook.com/dialog/feed?app_id=${environment.fbAppId}&display=popup&redirect_uri=https://www.facebook.com`;

@UntilDestroy()
@Component({
  selector: 'app-shared-organization-share',
  templateUrl: './organization-share.component.html',
  styleUrls: [
    './organization-share.component.scss',
    '../property-share-modal/property-share-modal.component.scss',
  ],
})
export class OrganizationShareComponent implements OnInit, OnChanges {
  @Input({ required: true }) open = false;
  @Output() handleClose = new EventEmitter<void>();

  protected organization: IOrganization | null | undefined;

  protected shareEmails = false;
  protected orgUrl = environment.url;
  protected shareContent = '';
  protected shareSMS = false;

  constructor(
    private state: Store<AppState>,
    private clipboard: Clipboard,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    this.state
      .select(selectAuthUser)
      .pipe(untilDestroyed(this))
      .subscribe((user) => {
        this.organization = user?.organization;
        if (user?.organization && user.organization.shortName) {
          this.orgUrl = `${
            environment.url
          }/o/${user.organization.shortName.toLocaleLowerCase()}`;
          this.shareContent =
            `Check out ${user.organization.name} marketplace on ` +
            `${environment.appName}: ${this.orgUrl}`;
        }
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['open'] && changes['open'].currentValue) {
      this.shareEmails = false;
    }
  }

  shareFacebook(): void {
    this.clipboard.copy(this.shareContent);
    window.alert(
      'Organization marketplace link copied to clipboard. Facebook will be opened in a new tab.'
    );
    window.open(fbUrl, '_blank');
  }

  shareWithBuyersList(): void {
    this.toastr.info(
      'This feature is not available yet. Please check back later.'
    );
  }
}
